export default "__VITE_ASSET__3bb34a9f__"